import React from 'react'
import BaseComponent from './BaseContainer'
import {Query} from 'react-apollo'
import PassportFideliteSubscribers from '../components/list/PassportFideliteSubscribers'
import getPassportFideliteSubscribers from '../apollo/graphql/passportfidelite-subscriber/get'
import deletePassportFideliteSubscriber from '../apollo/graphql/passportfidelite-subscriber/delete'
import {Loader, Message, Dimmer} from 'semantic-ui-react'
import {compose, graphql, withApollo} from 'react-apollo/index'

class PassportFideliteSubscribersContainer extends BaseComponent {

  constructor (props) {
    super(props)

    this.state = {
      status: {
        loading: true,
        message: null,
        error: null,
        deletion: { confirm: false }
      },
      redirect: false,
      obj: {
        email: null
      }
    }

    this.handleDelete = this.handleDelete.bind(this)
  }

  handleDelete (event, data) {
    event.preventDefault()
    let newState = {
      status: {
        ...this.state.status,
        deletion: {}
      }
    }
    switch (data.confirm) {
    case true:
      newState.status.deletion.confirm = true
      break
    case null:
      newState.status.deletion.confirm = false
      break
    case false:
      newState.status.deletion.confirm = false
      this.props.deletePassportFideliteSubscriber({ variables: { id: data.id } }).catch((error) => {
        this.setState({
          status: {
            ...this.state.status,
            loading: false,
            message: error.message,
            error: true
          }
        })
      })
      break
    default:
      break
    }
    this.setState(newState)
  }

  render () {
    return (
      <Query query={getPassportFideliteSubscribers} fetchPolicy='network-only'>
        {({ data, client, error, loading }) => {
          if (loading) {
            return (
              <Dimmer active inverted>
                <Loader inverted>Chargement</Loader>
              </Dimmer>
            )
          }
          if (error) {
            return (
              <Message negative>
                <Message.Header>Erreur</Message.Header>
                <p>{error.message}</p>
              </Message>
            )
          }
          return (
            <PassportFideliteSubscribers
              passportFideliteSubscribers={data.getPassportFideliteSubscribers}
              onDelete={this.handleDelete}
              status={this.state.status}
            />
          )
        }}
      </Query>
    )
  }
}

const PassportFideliteSubscribersContainerEnhanced = compose(
  graphql(deletePassportFideliteSubscriber, {
    name: 'deletePassportFideliteSubscriber',
    options: {
      update: (proxy, { data }) => {
        const passportfideliteSubscribers = proxy.readQuery({ query: getPassportFideliteSubscribers })
        passportfideliteSubscribers.getPassportFideliteSubscribers = passportfideliteSubscribers.getPassportFideliteSubscribers.filter(obj => obj.id !== data.deletePassportFideliteSubscriber.id)
        proxy.writeQuery({ query: getPassportFideliteSubscribers, data: passportfideliteSubscribers })
      }
    }
  })
)(PassportFideliteSubscribersContainer)

export default withApollo(PassportFideliteSubscribersContainerEnhanced)



// WEBPACK FOOTER //
// ./src/containers/PassportFideliteSubscribersContainer.js